var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 80,
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52619 15.5174L86.551 2.22567C88.187 1.96375 89.7256 3.07769 89.9875 4.71371C89.988 4.71698 89.9886 4.72026 89.9891 4.72353L98.1108 56.5556C98.3667 58.1887 97.2534 59.721 95.6212 59.9823L12.5964 73.274C10.9604 73.5359 9.42184 72.422 9.15992 70.786C9.1594 70.7827 9.15887 70.7794 9.15836 70.7762L1.03659 18.9441C0.780705 17.311 1.894 15.7787 3.52619 15.5174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9191 72.4234L13.7357 72.9482C11.549 73.3085 9.49562 71.756 9.14921 69.4805L1.62416 20.0391C1.27782 17.7636 2.76971 15.6268 4.95638 15.2664L85.1325 2.05195C87.3192 1.69162 89.3726 3.2441 89.719 5.51957C90.0564 7.73665 90.3253 9.50357 90.5257 10.8203M91.0973 14.5758C91.2789 15.7685 91.4378 16.8129 91.5742 17.7091",
    stroke: "#149CE0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55124 17.7922L83.3113 5.96116C84.9432 5.7063 86.4742 6.81858 86.7362 8.44942L94.0963 54.2685C94.3591 55.9043 93.246 57.4435 91.6101 57.7063C91.6058 57.707 91.6015 57.7077 91.5972 57.7083L15.8372 69.5394C14.2052 69.7943 12.6742 68.682 12.4123 67.0511L5.05209 21.2321C4.78931 19.5962 5.90243 18.0571 7.53831 17.7943C7.54262 17.7936 7.54693 17.7929 7.55124 17.7922Z",
    fill: "#E7F5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.324 22.25H25.8242C23.6151 22.25 21.8242 24.0409 21.8242 26.25V74.75C21.8242 76.9591 23.6151 78.75 25.8242 78.75H104.324C106.533 78.75 108.324 76.9591 108.324 74.75V26.25C108.324 24.0409 106.533 22.25 104.324 22.25Z",
    fill: "white",
    stroke: "#149CE0",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.074 34H23.0742V48H107.074V34Z",
    fill: "#E7F5FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8628 34H29.6664M107.745 34H41.9046H107.745ZM101.745 47H22.9053H101.745ZM58.6362 66H30.3284H58.6362Z",
    stroke: "#149CE0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCards);
export default __webpack_public_path__ + "static/media/debit_cards.be2113a2f253d84d174a28eaaa41b1f9.svg";
export { ForwardRef as ReactComponent };